<template>
	<div class="user-panel">
		<div class="user-panel__name">
			Пользователь:
			<strong>{{ username }}</strong>
		</div>
		<button class="user-panel__button" @click="onLogout()">Выйти</button>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
	name: "UserPanel",
	computed: {
		...mapGetters("User", ["username"])
	},
	methods: {
		...mapActions("User", ["logout"]),

		async onLogout() {
			await this.logout()

			this.$emit("logout")
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";

.user-panel {
	display: flex;
	align-items: center;

	&__name {
		margin: 0 20px;
	}
	&__button {
		@include button();
	}
}
</style>
